import React, { useState } from 'react';

import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';
import NewServiceModal from 'components/practice/Settings/components/Services/components/NewServiceModal/NewServiceModal';

const AddServiceActions = (params) => {
  const { data, context } = params;
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const options = [
    {
      label: 'Edit',
      onClick: () => setShowEditModal(true),
      icon: 'edit-2-mono'
    },
    {
      label: 'Remove',
      onClick: () => setShowDeleteModal(true),
      icon: 'trash-mono'
    }
  ];

  const onEditModalToggle = () => {
    setShowEditModal((prev) => !prev);
  };

  const handleRemove = () => {
    // Remove from grid
    if (context?.gridApi) {
      const transaction = context.gridApi.applyTransaction({
        remove: [data]
      });

      if (transaction) {
        // Clear local edits for this item
        if (context?.setLocalEdits) {
          context.setLocalEdits((prev) => {
            const { [data.code]: _, ...rest } = prev;
            return rest;
          });
        }
      }
    }
    setShowDeleteModal(false);
  };

  const onSave = async (updatedService) => {
    // Store the edits in local state so they persist across filter/pagination changes
    const updatedData = {
      name: updatedService.name,
      cpt_description: updatedService.name,
      self_pay: updatedService.total_cost_cents,
      total_cost_cents: updatedService.total_cost_cents,
      standard_charge: updatedService.standard_charge,
      par_amount: updatedService.par_amount || data.par_amount,
      also_known_as: updatedService.also_known_as,
      description: updatedService.description,
      time_length: updatedService.time_length,
      charge_type: updatedService.charge_type,
      color: updatedService.color,
      image: updatedService.image
    };

    // Update local edits state - this will trigger filteredData to recompute with the edit
    if (context?.setLocalEdits) {
      context.setLocalEdits((prev) => ({
        ...prev,
        [data.code]: updatedData
      }));
    }

    // Also update the grid immediately for visual feedback
    if (context?.gridApi) {
      const rowNode = context.gridApi.getRowNode(data.code);
      if (rowNode) {
        rowNode.setData({ ...data, ...updatedData });
      }
    }

    onEditModalToggle();
  };

  // Transform CPT data to service format for the modal
  // Use a special flag to indicate "edit mode" without a real database ID
  const serviceData = {
    ...data,
    id: `local-${data.code}`, // Use a prefix to indicate this is a local edit, not a DB record
    name: data.name || data.cpt_description,
    procedure_code: data.code,
    total_cost_cents: data.self_pay || data.total_cost_cents,
    standard_charge: data.standard_charge,
    par_amount: data.par_amount
  };

  return (
    <div className="flex h-full items-center justify-center">
      <Popover
        isFixed
        options={options}
        position="left"
        icon="context-menu-horizontal"
        className="flex flex-1 justify-center self-center"
      />
      {showEditModal && (
        <NewServiceModal
          service={serviceData}
          isOpen={showEditModal}
          onClose={onEditModalToggle}
          onSave={onSave}
        />
      )}
      {showDeleteModal && (
        <Confirm
          variant="danger"
          title="Remove service"
          icon="trash-mono"
          message="Are you sure you want to remove this service from the list?"
          handleOpen={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Remove service',
              onClick: handleRemove,
              color: 'danger'
            }
          }}
        />
      )}
    </div>
  );
};

export default AddServiceActions;
